import { NODE_ENV } from '@/config/global.config';
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { appServiceApi } from './apis/app-service.api';
import { authServiceApi } from './apis/auth-service.api';
import { invalidateAllTags } from './app.middleware';
import { authReducer } from './features/auth/auth.slice';
import policyReducer from './features/control-panel/policies/policies.slice';
import { onboardingReducer } from './features/onboarding/onboarding.slice';
import { discloserReducer } from './features/settings/discloser/discloser.slice';
import { filtersReducer } from './features/settings/filters/filters.slice';

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: {
    [authServiceApi.reducerPath]: authServiceApi.reducer,
    [appServiceApi.reducerPath]: appServiceApi.reducer,
    auth: authReducer,
    filters: filtersReducer,
    discloser: discloserReducer,
    onboarding: onboardingReducer,
    policies: policyReducer,
  },
  devTools: NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(authServiceApi.middleware)
      .concat(appServiceApi.middleware)
      .concat(invalidateAllTags([authServiceApi, appServiceApi])),
});

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();

export default store;
